export default function bulletData() {  return { bullets: [
    {
        "Caliber": "",
        "Name": "12/70 5.25mm buckshot",
        "FleshDamage": "8x37",
        "PenetrationPower": 1,
        "ArmorDamage": 15,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "12/70 8.5mm Magnum buckshot",
        "FleshDamage": "8x50",
        "PenetrationPower": 2,
        "ArmorDamage": 26,
        "Accuracy": -15,
        "Recoil": 115,
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "12/70 6.5mm Express buckshot",
        "FleshDamage": "9x35",
        "PenetrationPower": 3,
        "ArmorDamage": 26,
        "Accuracy": 15,
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "12/70 7mm buckshot",
        "FleshDamage": "8x39",
        "PenetrationPower": 3,
        "ArmorDamage": 26,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "12/70 flechette",
        "FleshDamage": "8x25",
        "PenetrationPower": 31,
        "ArmorDamage": 26,
        "Accuracy": -10,
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 5,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "12/70 RIP",
        "FleshDamage": 265,
        "PenetrationPower": 2,
        "ArmorDamage": 11,
        "Accuracy": 80,
        "Recoil": 35,
        "FragmentationChance": 100,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 SuperFormance HP slug",
        "FleshDamage": 220,
        "PenetrationPower": 5,
        "ArmorDamage": 12,
        "Accuracy": 170,
        "Recoil": -15,
        "FragmentationChance": 39,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 Grizzly 40 slug",
        "FleshDamage": 190,
        "PenetrationPower": 12,
        "ArmorDamage": 48,
        "Accuracy": 80,
        "Recoil": 20,
        "FragmentationChance": 12,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 Copper Sabot Premier HP slug",
        "FleshDamage": 206,
        "PenetrationPower": 14,
        "ArmorDamage": 46,
        "Accuracy": 150,
        "Recoil": 10,
        "FragmentationChance": 38,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 lead slug",
        "FleshDamage": 167,
        "PenetrationPower": 15,
        "ArmorDamage": 55,
        "Accuracy": 120,
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 'Poleva-3' slug",
        "FleshDamage": 140,
        "PenetrationPower": 17,
        "ArmorDamage": 40,
        "Accuracy": 110,
        "Recoil": -15,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 Dual Sabot slug",
        "FleshDamage": "2x85",
        "PenetrationPower": 17,
        "ArmorDamage": 65,
        "Accuracy": 100,
        "Recoil": 15,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 FTX Custom Lite slug",
        "FleshDamage": 183,
        "PenetrationPower": 20,
        "ArmorDamage": 50,
        "Accuracy": 135,
        "Recoil": -25,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 'Poleva-6u' slug",
        "FleshDamage": 150,
        "PenetrationPower": 20,
        "ArmorDamage": 50,
        "Accuracy": 115,
        "Recoil": -10,
        "FragmentationChance": 15,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 makeshift .50 BMG slug",
        "FleshDamage": 197,
        "PenetrationPower": 26,
        "ArmorDamage": 57,
        "Accuracy": 90,
        "Recoil": 25,
        "FragmentationChance": 5,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 3,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12/70 AP-20 armor-piercing slug",
        "FleshDamage": 164,
        "PenetrationPower": 37,
        "ArmorDamage": 65,
        "Accuracy": 80,
        "Recoil": 50,
        "FragmentationChance": 3,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "20/70 5.6mm buckshot",
        "FleshDamage": "8x26",
        "PenetrationPower": 1,
        "ArmorDamage": 12,
        "Accuracy": -10,
        "Recoil": 10,
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "20/70 'explosive' slug",
        "FleshDamage": 51,
        "PenetrationPower": 1,
        "ArmorDamage": 72,
        "Accuracy": -7,
        "Recoil": 25,
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "20/70 6.2mm buckshot",
        "FleshDamage": "8x22",
        "PenetrationPower": 2,
        "ArmorDamage": 13,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "20/70 7.5mm buckshot",
        "FleshDamage": "8x25",
        "PenetrationPower": 3,
        "ArmorDamage": 14,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "20/70 7.3mm buckshot",
        "FleshDamage": "9x23",
        "PenetrationPower": 3,
        "ArmorDamage": 13,
        "Accuracy": "",
        "Recoil": 15,
        "FragmentationChance": 0,
        "Armor1": 3,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "20/70 Devastator slug",
        "FleshDamage": 198,
        "PenetrationPower": 5,
        "ArmorDamage": 13,
        "Accuracy": 125,
        "Recoil": 30,
        "FragmentationChance": 100,
        "Armor1": 1,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "20/70 'Poleva-3' slug",
        "FleshDamage": 120,
        "PenetrationPower": 14,
        "ArmorDamage": 35,
        "Accuracy": 110,
        "Recoil": -15,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "20/70 Star slug",
        "FleshDamage": 154,
        "PenetrationPower": 16,
        "ArmorDamage": 42,
        "Accuracy": 130,
        "Recoil": 5,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "20/70 'Poleva-6u' slug",
        "FleshDamage": 135,
        "PenetrationPower": 17,
        "ArmorDamage": 40,
        "Accuracy": 110,
        "Recoil": -10,
        "FragmentationChance": 15,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "20/70 'Flechetta Plus'",
        "FleshDamage": "4x71",
        "PenetrationPower": 45,
        "ArmorDamage": 47,
        "Accuracy": "",
        "Recoil": 25,
        "FragmentationChance": 0,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "20/70 Elephant killer slug",
        "FleshDamage": 108,
        "PenetrationPower": 47,
        "ArmorDamage": 70,
        "Accuracy": -5,
        "Recoil": 30,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "23x75mm 'Zvezda' flashbang round",
        "FleshDamage": 0,
        "PenetrationPower": 0,
        "ArmorDamage": 0,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "23x75mm 'Shrapnel-25' buckshot",
        "FleshDamage": "8x78",
        "PenetrationPower": 10,
        "ArmorDamage": 20,
        "Accuracy": 20,
        "Recoil": 10,
        "FragmentationChance": 0,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "23x75mm 'Shrapnel-10' buckshot",
        "FleshDamage": "8x87",
        "PenetrationPower": 11,
        "ArmorDamage": 20,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "23x75mm 'Barrikada' slug",
        "FleshDamage": 192,
        "PenetrationPower": 39,
        "ArmorDamage": 75,
        "Accuracy": -5,
        "Recoil": 25,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM SP8 gzh",
        "FleshDamage": 67,
        "PenetrationPower": 1,
        "ArmorDamage": 2,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 60,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM SP7 gzh",
        "FleshDamage": 77,
        "PenetrationPower": 2,
        "ArmorDamage": 5,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 2,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PSV",
        "FleshDamage": 69,
        "PenetrationPower": 3,
        "ArmorDamage": 5,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 40,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM P gzh",
        "FleshDamage": 50,
        "PenetrationPower": 5,
        "ArmorDamage": 16,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 2,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PSO gzh",
        "FleshDamage": 54,
        "PenetrationPower": 5,
        "ArmorDamage": 13,
        "Accuracy": 10,
        "Recoil": "",
        "FragmentationChance": 35,
        "Armor1": 2,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PS gs PPO",
        "FleshDamage": 55,
        "PenetrationPower": 6,
        "ArmorDamage": 16,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 3,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PRS gs",
        "FleshDamage": 58,
        "PenetrationPower": 6,
        "ArmorDamage": 16,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 30,
        "Armor1": 3,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PPe gzh",
        "FleshDamage": 61,
        "PenetrationPower": 7,
        "ArmorDamage": 15,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 35,
        "Armor1": 4,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PPT gzh",
        "FleshDamage": 59,
        "PenetrationPower": 8,
        "ArmorDamage": 22,
        "Accuracy": -5,
        "Recoil": -7,
        "FragmentationChance": 17,
        "Armor1": 5,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM Pst gzh",
        "FleshDamage": 50,
        "PenetrationPower": 12,
        "ArmorDamage": 26,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM RG028 gzh",
        "FleshDamage": 65,
        "PenetrationPower": 13,
        "ArmorDamage": 26,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 2,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM BZhT gzh",
        "FleshDamage": 53,
        "PenetrationPower": 18,
        "ArmorDamage": 28,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PMM PstM gzh",
        "FleshDamage": 58,
        "PenetrationPower": 24,
        "ArmorDamage": 33,
        "Accuracy": "",
        "Recoil": 5,
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 4,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x18mm PM PBM gzh",
        "FleshDamage": 40,
        "PenetrationPower": 28,
        "ArmorDamage": 30,
        "Accuracy": "",
        "Recoil": 4,
        "FragmentationChance": 16,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT LRNPC",
        "FleshDamage": 66,
        "PenetrationPower": 7,
        "ArmorDamage": 27,
        "Accuracy": 10,
        "Recoil": -10,
        "FragmentationChance": 35,
        "Armor1": 5,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT LRN",
        "FleshDamage": 64,
        "PenetrationPower": 8,
        "ArmorDamage": 28,
        "Accuracy": 5,
        "Recoil": -5,
        "FragmentationChance": 35,
        "Armor1": 5,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT FMJ43",
        "FleshDamage": 60,
        "PenetrationPower": 11,
        "ArmorDamage": 29,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT AKBS",
        "FleshDamage": 58,
        "PenetrationPower": 12,
        "ArmorDamage": 32,
        "Accuracy": 15,
        "Recoil": -15,
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT P gl",
        "FleshDamage": 58,
        "PenetrationPower": 14,
        "ArmorDamage": 32,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT PT gzh",
        "FleshDamage": 55,
        "PenetrationPower": 18,
        "ArmorDamage": 34,
        "Accuracy": -10,
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x25mm TT Pst gzh",
        "FleshDamage": 50,
        "PenetrationPower": 25,
        "ArmorDamage": 36,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 4,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm RIP",
        "FleshDamage": 102,
        "PenetrationPower": 2,
        "ArmorDamage": 11,
        "Accuracy": "",
        "Recoil": 20,
        "FragmentationChance": 100,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm QuakeMaker",
        "FleshDamage": 85,
        "PenetrationPower": 8,
        "ArmorDamage": 22,
        "Accuracy": 10,
        "Recoil": 10,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm PSO gzh",
        "FleshDamage": 59,
        "PenetrationPower": 10,
        "ArmorDamage": 32,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm Luger CCI",
        "FleshDamage": 70,
        "PenetrationPower": 10,
        "ArmorDamage": 38,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm Green Tracer",
        "FleshDamage": 58,
        "PenetrationPower": 14,
        "ArmorDamage": 33,
        "Accuracy": -5,
        "Recoil": -6,
        "FragmentationChance": 15,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm Pst gzh",
        "FleshDamage": 54,
        "PenetrationPower": 20,
        "ArmorDamage": 33,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 15,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x19mm AP 6.3",
        "FleshDamage": 52,
        "PenetrationPower": 30,
        "ArmorDamage": 48,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 5,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 4,
        "Armor5": 2,
        "Armor6": 1
    },
    {
        "Caliber": "",
        "Name": "9x19mm PBP gzh",
        "FleshDamage": 52,
        "PenetrationPower": 39,
        "ArmorDamage": 53,
        "Accuracy": 5,
        "Recoil": 15,
        "FragmentationChance": 5,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": ".357 Magnum SP",
        "FleshDamage": 108,
        "PenetrationPower": 12,
        "ArmorDamage": 15,
        "Accuracy": 27,
        "Recoil": -29,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".357 Magnum HP",
        "FleshDamage": 99,
        "PenetrationPower": 18,
        "ArmorDamage": 20,
        "Accuracy": 15,
        "Recoil": 15,
        "FragmentationChance": 60,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".357 Magnum JHP",
        "FleshDamage": 88,
        "PenetrationPower": 24,
        "ArmorDamage": 28,
        "Accuracy": 15,
        "Recoil": 8,
        "FragmentationChance": 60,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".357 Magnum FMJ",
        "FleshDamage": 70,
        "PenetrationPower": 35,
        "ArmorDamage": 43,
        "Accuracy": "",
        "Recoil": 12,
        "FragmentationChance": 1,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 2,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".45 ACP RIP",
        "FleshDamage": 130,
        "PenetrationPower": 3,
        "ArmorDamage": 12,
        "Accuracy": -5,
        "Recoil": "",
        "FragmentationChance": 100,
        "Armor1": 1,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".45 ACP Hydra-Shok",
        "FleshDamage": 100,
        "PenetrationPower": 13,
        "ArmorDamage": 30,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 50,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".45 ACP Lasermatch FMJ",
        "FleshDamage": 76,
        "PenetrationPower": 19,
        "ArmorDamage": 37,
        "Accuracy": 10,
        "Recoil": "",
        "FragmentationChance": 1,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".45 ACP Match FMJ",
        "FleshDamage": 72,
        "PenetrationPower": 25,
        "ArmorDamage": 36,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 1,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 3,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".45 ACP AP",
        "FleshDamage": 66,
        "PenetrationPower": 38,
        "ArmorDamage": 48,
        "Accuracy": -5,
        "Recoil": 7,
        "FragmentationChance": 1,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "9x21mm PE gzh",
        "FleshDamage": 80,
        "PenetrationPower": 15,
        "ArmorDamage": 63,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 35,
        "Armor1": 6,
        "Armor2": 2,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x21mm P gzh",
        "FleshDamage": 65,
        "PenetrationPower": 18,
        "ArmorDamage": 44,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "9x21mm PS gzh",
        "FleshDamage": 49,
        "PenetrationPower": 35,
        "ArmorDamage": 46,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 4,
        "Armor5": 3,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "9x21mm BT gzh",
        "FleshDamage": 63,
        "PenetrationPower": 39,
        "ArmorDamage": 47,
        "Accuracy": -4,
        "Recoil": -4,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm R37.F",
        "FleshDamage": 98,
        "PenetrationPower": 8,
        "ArmorDamage": 7,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 100,
        "Armor1": 4,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm SS198LF",
        "FleshDamage": 74,
        "PenetrationPower": 10,
        "ArmorDamage": 15,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 80,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm R37.X",
        "FleshDamage": 81,
        "PenetrationPower": 11,
        "ArmorDamage": 14,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 70,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm SS197SR",
        "FleshDamage": 62,
        "PenetrationPower": 20,
        "ArmorDamage": 22,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 50,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm L191",
        "FleshDamage": 58,
        "PenetrationPower": 33,
        "ArmorDamage": 41,
        "Accuracy": -4,
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 3,
        "Armor5": 2,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm SB193",
        "FleshDamage": 54,
        "PenetrationPower": 35,
        "ArmorDamage": 37,
        "Accuracy": 5,
        "Recoil": -24,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 4,
        "Armor5": 3,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "5.7x28mm SS190",
        "FleshDamage": 49,
        "PenetrationPower": 37,
        "ArmorDamage": 43,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "4.6x30mm Action SX",
        "FleshDamage": 65,
        "PenetrationPower": 18,
        "ArmorDamage": 39,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 50,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "4.6x30mm Subsonic SX",
        "FleshDamage": 45,
        "PenetrationPower": 36,
        "ArmorDamage": 46,
        "Accuracy": 10,
        "Recoil": -22,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 3,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "4.6x30mm FMJ SX",
        "FleshDamage": 43,
        "PenetrationPower": 40,
        "ArmorDamage": 41,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "4.6x30mm AP SX",
        "FleshDamage": 35,
        "PenetrationPower": 53,
        "ArmorDamage": 46,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "9x39mm SP-5 gs",
        "FleshDamage": 71,
        "PenetrationPower": 28,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": -5,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 3,
        "Armor5": 2,
        "Armor6": 1
    },
    {
        "Caliber": "",
        "Name": "9x39mm SPP gs",
        "FleshDamage": 68,
        "PenetrationPower": 40,
        "ArmorDamage": 55,
        "Accuracy": 10,
        "Recoil": 10,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "9x39mm SP-6 gs",
        "FleshDamage": 58,
        "PenetrationPower": 46,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "9x39mm PAB-9 gs",
        "FleshDamage": 62,
        "PenetrationPower": 48,
        "ArmorDamage": 72,
        "Accuracy": -15,
        "Recoil": 10,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "9x39mm BP gs",
        "FleshDamage": 60,
        "PenetrationPower": 55,
        "ArmorDamage": 68,
        "Accuracy": 10,
        "Recoil": 22,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": ".366 TKM Geksa",
        "FleshDamage": 110,
        "PenetrationPower": 14,
        "ArmorDamage": 38,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 45,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".366 TKM FMJ",
        "FleshDamage": 98,
        "PenetrationPower": 23,
        "ArmorDamage": 48,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 4,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".366 TKM EKO",
        "FleshDamage": 73,
        "PenetrationPower": 30,
        "ArmorDamage": 40,
        "Accuracy": -10,
        "Recoil": -15,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 3,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".366 TKM AP-M",
        "FleshDamage": 90,
        "PenetrationPower": 42,
        "ArmorDamage": 60,
        "Accuracy": -28,
        "Recoil": 35,
        "FragmentationChance": 1,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm SP",
        "FleshDamage": 68,
        "PenetrationPower": 13,
        "ArmorDamage": 34,
        "Accuracy": 10,
        "Recoil": -15,
        "FragmentationChance": 45,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm HP",
        "FleshDamage": 74,
        "PenetrationPower": 12,
        "ArmorDamage": 20,
        "Accuracy": "",
        "Recoil": 5,
        "FragmentationChance": 35,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm PRS gs",
        "FleshDamage": 60,
        "PenetrationPower": 12,
        "ArmorDamage": 28,
        "Accuracy": "",
        "Recoil": -5,
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 1,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm US gs",
        "FleshDamage": 65,
        "PenetrationPower": 15,
        "ArmorDamage": 34,
        "Accuracy": "",
        "Recoil": -25,
        "FragmentationChance": 10,
        "Armor1": 6,
        "Armor2": 3,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm FMJ",
        "FleshDamage": 56,
        "PenetrationPower": 21,
        "ArmorDamage": 30,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm T gs",
        "FleshDamage": 57,
        "PenetrationPower": 20,
        "ArmorDamage": 38,
        "Accuracy": -5,
        "Recoil": -5,
        "FragmentationChance": 16,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm PS gs",
        "FleshDamage": 48,
        "PenetrationPower": 31,
        "ArmorDamage": 35,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 40,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 2,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm PP gs",
        "FleshDamage": 44,
        "PenetrationPower": 36,
        "ArmorDamage": 38,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 4,
        "Armor5": 3,
        "Armor6": 1
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm BP gs",
        "FleshDamage": 45,
        "PenetrationPower": 37,
        "ArmorDamage": 41,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 16,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 4,
        "Armor5": 3,
        "Armor6": 1
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm BT gs",
        "FleshDamage": 42,
        "PenetrationPower": 40,
        "ArmorDamage": 35,
        "Accuracy": -2,
        "Recoil": 3,
        "FragmentationChance": 16,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm 7N40",
        "FleshDamage": 52,
        "PenetrationPower": 44,
        "ArmorDamage": 50,
        "Accuracy": 50,
        "Recoil": -20,
        "FragmentationChance": 2,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm BS gs",
        "FleshDamage": 40,
        "PenetrationPower": 51,
        "ArmorDamage": 57,
        "Accuracy": -3,
        "Recoil": 10,
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "5.45x39mm PPBS gs 'Igolnik'",
        "FleshDamage": 37,
        "PenetrationPower": 62,
        "ArmorDamage": 55,
        "Accuracy": "",
        "Recoil": 15,
        "FragmentationChance": 2,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm Warmageddon",
        "FleshDamage": 88,
        "PenetrationPower": 3,
        "ArmorDamage": 11,
        "Accuracy": 10,
        "Recoil": 10,
        "FragmentationChance": 90,
        "Armor1": 1,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm HP",
        "FleshDamage": 79,
        "PenetrationPower": 8,
        "ArmorDamage": 22,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 70,
        "Armor1": 5,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm MK 255 Mod 0 (RRLP)",
        "FleshDamage": 63,
        "PenetrationPower": 18,
        "ArmorDamage": 32,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 3,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm MK 318 Mod 0 (SOST)",
        "FleshDamage": 69,
        "PenetrationPower": 20,
        "ArmorDamage": 35,
        "Accuracy": 10,
        "Recoil": "",
        "FragmentationChance": 15,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 2,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm M856",
        "FleshDamage": 59,
        "PenetrationPower": 23,
        "ArmorDamage": 34,
        "Accuracy": -2,
        "Recoil": -2,
        "FragmentationChance": 33,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 3,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm FMJ",
        "FleshDamage": 54,
        "PenetrationPower": 23,
        "ArmorDamage": 33,
        "Accuracy": 10,
        "Recoil": -5,
        "FragmentationChance": 50,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 4,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm M855",
        "FleshDamage": 53,
        "PenetrationPower": 30,
        "ArmorDamage": 37,
        "Accuracy": -5,
        "Recoil": "",
        "FragmentationChance": 40,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 3,
        "Armor5": 2,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm M856A1",
        "FleshDamage": 54,
        "PenetrationPower": 37,
        "ArmorDamage": 52,
        "Accuracy": -1,
        "Recoil": 4,
        "FragmentationChance": 33,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm M855A1",
        "FleshDamage": 49,
        "PenetrationPower": 44,
        "ArmorDamage": 52,
        "Accuracy": -10,
        "Recoil": 5,
        "FragmentationChance": 34,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm M995",
        "FleshDamage": 42,
        "PenetrationPower": 53,
        "ArmorDamage": 58,
        "Accuracy": "",
        "Recoil": 8,
        "FragmentationChance": 32,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "5.56x45mm SSA AP",
        "FleshDamage": 38,
        "PenetrationPower": 57,
        "ArmorDamage": 64,
        "Accuracy": -6,
        "Recoil": 6,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": ".300 Whisper",
        "FleshDamage": 90,
        "PenetrationPower": 14,
        "ArmorDamage": 19,
        "Accuracy": 5,
        "Recoil": -5,
        "FragmentationChance": 35,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 2,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".300 Blackout V-Max",
        "FleshDamage": 72,
        "PenetrationPower": 20,
        "ArmorDamage": 25,
        "Accuracy": 30,
        "Recoil": -10,
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 4,
        "Armor4": 3,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".300 Blackout BCP FMJ",
        "FleshDamage": 60,
        "PenetrationPower": 30,
        "ArmorDamage": 36,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 3,
        "Armor5": 2,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".300 Blackout M62 Tracer",
        "FleshDamage": 54,
        "PenetrationPower": 36,
        "ArmorDamage": 40,
        "Accuracy": "",
        "Recoil": 5,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": ".300 Blackout AP",
        "FleshDamage": 51,
        "PenetrationPower": 48,
        "ArmorDamage": 65,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm HP",
        "FleshDamage": 87,
        "PenetrationPower": 15,
        "ArmorDamage": 35,
        "Accuracy": -5,
        "Recoil": "",
        "FragmentationChance": 26,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 1,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm US gzh",
        "FleshDamage": 56,
        "PenetrationPower": 29,
        "ArmorDamage": 42,
        "Accuracy": 5,
        "Recoil": -30,
        "FragmentationChance": 8,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 3,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm T-45M1 gzh",
        "FleshDamage": 64,
        "PenetrationPower": 30,
        "ArmorDamage": 46,
        "Accuracy": -4,
        "Recoil": -6,
        "FragmentationChance": 12,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 3,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm PS gzh",
        "FleshDamage": 57,
        "PenetrationPower": 35,
        "ArmorDamage": 52,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 3,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm BP gzh",
        "FleshDamage": 58,
        "PenetrationPower": 47,
        "ArmorDamage": 63,
        "Accuracy": -3,
        "Recoil": 5,
        "FragmentationChance": 12,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "7.62x39mm MAI AP",
        "FleshDamage": 46,
        "PenetrationPower": 58,
        "ArmorDamage": 76,
        "Accuracy": -5,
        "Recoil": 10,
        "FragmentationChance": 5,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm Ultra Nosler",
        "FleshDamage": 107,
        "PenetrationPower": 15,
        "ArmorDamage": 20,
        "Accuracy": 10,
        "Recoil": -5,
        "FragmentationChance": 70,
        "Armor1": 6,
        "Armor2": 4,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm BCP FMJ",
        "FleshDamage": 88,
        "PenetrationPower": 31,
        "ArmorDamage": 33,
        "Accuracy": "",
        "Recoil": -3,
        "FragmentationChance": 25,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 2,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm TCW SP",
        "FleshDamage": 67,
        "PenetrationPower": 34,
        "ArmorDamage": 40,
        "Accuracy": -8,
        "Recoil": -5,
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 2,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm M80",
        "FleshDamage": 80,
        "PenetrationPower": 41,
        "ArmorDamage": 66,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm M62 Tracer",
        "FleshDamage": 79,
        "PenetrationPower": 44,
        "ArmorDamage": 75,
        "Accuracy": -6,
        "Recoil": -5,
        "FragmentationChance": 14,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm M61",
        "FleshDamage": 70,
        "PenetrationPower": 64,
        "ArmorDamage": 83,
        "Accuracy": 3,
        "Recoil": 10,
        "FragmentationChance": 13,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "7.62x51mm M993",
        "FleshDamage": 67,
        "PenetrationPower": 70,
        "ArmorDamage": 85,
        "Accuracy": 5,
        "Recoil": 8,
        "FragmentationChance": 13,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R T-46M gzh",
        "FleshDamage": 82,
        "PenetrationPower": 41,
        "ArmorDamage": 83,
        "Accuracy": -1,
        "Recoil": -5,
        "FragmentationChance": 18,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R LPS gzh",
        "FleshDamage": 81,
        "PenetrationPower": 42,
        "ArmorDamage": 78,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 18,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 4,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R PS gzh",
        "FleshDamage": 84,
        "PenetrationPower": 45,
        "ArmorDamage": 84,
        "Accuracy": 10,
        "Recoil": 8,
        "FragmentationChance": 8,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R BT gzh",
        "FleshDamage": 78,
        "PenetrationPower": 55,
        "ArmorDamage": 87,
        "Accuracy": -2,
        "Recoil": -4,
        "FragmentationChance": 8,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R SNB gzh",
        "FleshDamage": 75,
        "PenetrationPower": 62,
        "ArmorDamage": 87,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 8,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "7.62x54mm R BS gs",
        "FleshDamage": 72,
        "PenetrationPower": 70,
        "ArmorDamage": 88,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 8,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": ".338 Lapua Magnum TAC-X",
        "FleshDamage": 196,
        "PenetrationPower": 18,
        "ArmorDamage": 55,
        "Accuracy": 10,
        "Recoil": 5,
        "FragmentationChance": 50,
        "Armor1": 6,
        "Armor2": 5,
        "Armor3": 3,
        "Armor4": 1,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": ".338 Lapua Magnum UCW",
        "FleshDamage": 142,
        "PenetrationPower": 32,
        "ArmorDamage": 70,
        "Accuracy": -5,
        "Recoil": "",
        "FragmentationChance": 60,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 5,
        "Armor5": 4,
        "Armor6": 2
    },
    {
        "Caliber": "",
        "Name": ".338 Lapua Magnum FMJ",
        "FleshDamage": 122,
        "PenetrationPower": 47,
        "ArmorDamage": 83,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 20,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 5
    },
    {
        "Caliber": "",
        "Name": ".338 Lapua Magnum AP",
        "FleshDamage": 115,
        "PenetrationPower": 79,
        "ArmorDamage": 89,
        "Accuracy": "",
        "Recoil": 10,
        "FragmentationChance": 13,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "12.7x55mm PS12A",
        "FleshDamage": 165,
        "PenetrationPower": 10,
        "ArmorDamage": 22,
        "Accuracy": -15,
        "Recoil": -12,
        "FragmentationChance": 70,
        "Armor1": 6,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12.7x55mm PS12",
        "FleshDamage": 115,
        "PenetrationPower": 28,
        "ArmorDamage": 60,
        "Accuracy": 10,
        "Recoil": "",
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 5,
        "Armor4": 2,
        "Armor5": 1,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12.7x55mm PS12B",
        "FleshDamage": 102,
        "PenetrationPower": 46,
        "ArmorDamage": 57,
        "Accuracy": "",
        "Recoil": 15,
        "FragmentationChance": 30,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 5,
        "Armor6": 4
    },
    {
        "Caliber": "",
        "Name": "40x46mm M576 (MP-APERS) grenade",
        "FleshDamage": "15x160",
        "PenetrationPower": 5,
        "ArmorDamage": 95,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 5,
        "Armor2": 3,
        "Armor3": 3,
        "Armor4": 3,
        "Armor5": 3,
        "Armor6": 3
    },
    {
        "Caliber": "",
        "Name": "30x29mm VOG-30",
        "FleshDamage": 199,
        "PenetrationPower": 1,
        "ArmorDamage": 95,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "12.7x108mm B-32",
        "FleshDamage": 182,
        "PenetrationPower": 88,
        "ArmorDamage": 88,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "12.7x108mm BZT-44M",
        "FleshDamage": 199,
        "PenetrationPower": 80,
        "ArmorDamage": 95,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 17,
        "Armor1": 6,
        "Armor2": 6,
        "Armor3": 6,
        "Armor4": 6,
        "Armor5": 6,
        "Armor6": 6
    },
    {
        "Caliber": "",
        "Name": "26x75mm flare cartridge (White)",
        "FleshDamage": 37,
        "PenetrationPower": 0,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "26x75mm flare cartridge (Green)",
        "FleshDamage": 37,
        "PenetrationPower": 0,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "26x75mm flare cartridge (Red)",
        "FleshDamage": 37,
        "PenetrationPower": 0,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "26x75mm flare cartridge (Yellow)",
        "FleshDamage": 37,
        "PenetrationPower": 0,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    },
    {
        "Caliber": "",
        "Name": "26x75mm distress signal flare (poison green)",
        "FleshDamage": 37,
        "PenetrationPower": 0,
        "ArmorDamage": 60,
        "Accuracy": "",
        "Recoil": "",
        "FragmentationChance": 0,
        "Armor1": 0,
        "Armor2": 0,
        "Armor3": 0,
        "Armor4": 0,
        "Armor5": 0,
        "Armor6": 0
    }
]} }